(() => {
  const T = window.theme || { routes: {}, strings: {} };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');

  const openDialog = (id, opener) => {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open) return;
    $$('dialog[open]').forEach((d) => d.close());
    dialog.showModal();
    if (opener) {
      opener.setAttribute('aria-expanded', 'true');
      dialog._opener = opener;
    }
    const input = $('input[type="search"], input[type="password"]', dialog);
    if (input) input.focus();
  };

  document.addEventListener('close', (event) => {
    const dialog = event.target;
    if (dialog.tagName !== 'DIALOG' || !dialog._opener) return;
    dialog._opener.setAttribute('aria-expanded', 'false');
    dialog._opener = null;
  }, true);

  const cartDrawerEnabled = () => T.cartType === 'drawer' && document.getElementById('cart-drawer') && !document.body.classList.contains('t-cart');

  document.addEventListener('click', (event) => {
    const target = event.target;

    const opener = target.closest('[data-open]');
    if (opener) {
      event.preventDefault();
      openDialog(opener.dataset.open, opener);
      return;
    }

    const closer = target.closest('[data-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }

    if (target.tagName === 'DIALOG' && target.open) {
      const r = target.getBoundingClientRect();
      const inside = event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
      if (!inside) target.close();
      return;
    }

    const cartToggle = target.closest('[data-cart-toggle]');
    if (cartToggle && cartDrawerEnabled()) {
      event.preventDefault();
      openDialog('cart-drawer', cartToggle);
      return;
    }

    const step = target.closest('[data-gallery-step]');
    if (step) {
      const track = step.closest('.gallery')?.querySelector('[data-gallery-track]');
      if (!track) return;
      const count = track.children.length;
      const next = Math.min(count - 1, Math.max(0, Math.round(track.scrollLeft / track.clientWidth) + Number(step.dataset.galleryStep)));
      track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
      return;
    }

    const qtyButton = target.closest('[data-qty-change]');
    if (qtyButton) {
      const line = qtyButton.closest('[data-line]');
      if (!line) return;
      event.preventDefault();
      changeLine(Number(line.dataset.line), Math.max(0, Number(qtyButton.dataset.qtyChange)));
    }
  });

  document.addEventListener('change', (event) => {
    const el = event.target;
    if (el.matches('[data-autosubmit]')) el.form.submit();
    if (el.matches('[data-qty-input]')) {
      const line = el.closest('[data-line]');
      if (line) changeLine(Number(line.dataset.line), Math.max(0, parseInt(el.value, 10) || 0));
    }
  });

  const onScroll = () => document.documentElement.classList.toggle('is-scrolled', window.scrollY > 4);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* Cart */
  const cartSectionIds = () => [...new Set($$('[data-cart-section]').map((el) => el.dataset.cartSection))];

  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; });
  };

  const renderSections = (sections) => {
    if (!sections) return;
    Object.entries(sections).forEach(([id, html]) => {
      if (!html) return;
      const fresh = $(`[data-cart-section="${id}"]`, parse(html));
      if (!fresh) return;
      $$(`[data-cart-section="${id}"]`).forEach((live) => {
        live.innerHTML = fresh.innerHTML;
        live.dataset.count = fresh.dataset.count;
      });
      if (fresh.dataset.count !== undefined) updateCount(fresh.dataset.count);
    });
  };

  let cartBusy = false;
  const changeLine = async (line, quantity) => {
    if (cartBusy) return;
    cartBusy = true;
    const containers = $$('[data-cart-section]');
    containers.forEach((el) => el.classList.add('is-busy'));
    try {
      const res = await fetch(T.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: cartSectionIds(), sections_url: window.location.pathname })
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || T.strings.error);
      renderSections(json.sections);
    } catch (err) {
      window.alert(err.message || T.strings.error);
    } finally {
      containers.forEach((el) => el.classList.remove('is-busy'));
      $$('[data-cart-section]').forEach((el) => el.classList.remove('is-busy'));
      cartBusy = false;
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('.filters, .sort')) return;
    [...form.elements].forEach((el) => {
      if (el.name && el.type !== 'checkbox' && el.value === '') el.disabled = true;
    });
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.classList.contains('product-form') || !cartDrawerEnabled()) return;
    event.preventDefault();
    const button = $('[data-add-button]', form);
    const error = $('[data-form-error]', form);
    const label = button.textContent;
    button.disabled = true;
    button.textContent = T.strings.adding;
    if (error) error.hidden = true;
    let ok = false;
    try {
      const body = new FormData(form);
      body.append('sections', cartSectionIds().join(','));
      body.append('sections_url', window.location.pathname);
      const res = await fetch(T.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body
      });
      const json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || json.message || T.strings.error);
      renderSections(json.sections);
      ok = true;
    } catch (err) {
      if (error) {
        error.textContent = err.message || T.strings.error;
        error.hidden = false;
      }
    } finally {
      button.disabled = false;
      button.textContent = label;
    }
    if (ok) openDialog('cart-drawer');
  });

  /* Product */
  const initProduct = (root) => {
    const picker = $('[data-variant-picker]', root);
    const data = picker && $('[data-variants]', picker);
    const track = $('[data-gallery-track]', root);
    const counter = $('[data-gallery-index]', root);

    if (track && counter) {
      track.addEventListener('scroll', () => {
        counter.textContent = Math.round(track.scrollLeft / track.clientWidth) + 1;
      }, { passive: true });
    }

    if (!picker || !data) return;
    const variants = JSON.parse(data.textContent);
    const fieldsets = $$('fieldset', picker);

    picker.addEventListener('change', () => {
      const selected = fieldsets.map((fs) => $('input:checked', fs)?.value);
      const variant = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));

      fieldsets.forEach((fs, i) => {
        const current = $('[data-option-value]', fs);
        if (current) current.textContent = selected[i];
        $$('input', fs).forEach((input) => {
          const available = variants.some((v) => v.available && v.options[i] === input.value && v.options.every((opt, j) => j === i || opt === selected[j]));
          input.nextElementSibling.classList.toggle('is-unavailable', !available);
        });
      });

      const idInput = $('[data-variant-id]', root);
      const button = $('[data-add-button]', root);
      const price = $('[data-price]', root);
      if (!variant) {
        if (button) {
          button.disabled = true;
          button.textContent = T.strings.unavailable;
        }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;
      }
      if (price) {
        price.classList.toggle('price--sale', Boolean(variant.compare));
        price.innerHTML = `<span class="price__now">${variant.price}</span>${variant.compare ? `<s class="price__was">${variant.compare}</s>` : ''}`;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);

      if (variant.media && track && track.scrollWidth > track.clientWidth) {
        const item = $(`[data-media-id="${variant.media}"]`, track);
        if (item) track.scrollTo({ left: item.offsetLeft, behavior: 'smooth' });
      }
    });
  };

  /* Predictive search */
  const initSearch = () => {
    const input = $('[data-predictive-input]');
    const results = $('[data-predictive-results]');
    if (!input || !results || !T.routes.predictiveSearch) return;
    let timer;
    let controller;
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (!q) {
        controller?.abort();
        results.innerHTML = '';
        return;
      }
      timer = setTimeout(async () => {
        controller?.abort();
        controller = new AbortController();
        const params = new URLSearchParams({
          q,
          section_id: 'predictive-search',
          'resources[type]': 'product',
          'resources[limit]': '8',
          'resources[options][unavailable_products]': 'last'
        });
        try {
          const res = await fetch(`${T.routes.predictiveSearch}?${params}`, { signal: controller.signal });
          const fresh = $('[data-predictive]', parse(await res.text()));
          results.innerHTML = fresh ? fresh.outerHTML : '';
        } catch (err) {
          if (err.name !== 'AbortError') results.innerHTML = '';
        }
      }, 220);
    });
  };

  /* Recommendations */
  const initRecommendations = (root) => {
    $$('[data-recommendations]', root).forEach(async (el) => {
      if (el.children.length) return;
      try {
        const res = await fetch(el.dataset.url);
        const fresh = $('[data-recommendations]', parse(await res.text()));
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      } catch (err) {
        /* recommendations are optional */
      }
    });
  };

  /* Scale big wordmarks to exactly fill their container */
  const fitText = () => {
    $$('[data-fit-text]').forEach((el) => {
      const span = el.firstElementChild;
      if (!span) return;
      el.style.fontSize = '100px';
      const width = span.getBoundingClientRect().width;
      if (width) el.style.fontSize = `${(100 * el.clientWidth / width) * 0.99}px`;
    });
  };
  let fitTimer;
  window.addEventListener('resize', () => {
    clearTimeout(fitTimer);
    fitTimer = setTimeout(fitText, 100);
  });

  const init = (root = document) => {
    $$('[data-product]', root).forEach(initProduct);
    initRecommendations(root);
    fitText();
  };
  if (document.fonts) document.fonts.ready.then(fitText);

  document.addEventListener('DOMContentLoaded', () => {
    init();
    initSearch();
    const auto = $('dialog[data-autoopen]');
    if (auto) auto.showModal();
  });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
